export default "__VITE_ASSET__BV3dX$OL__"